import dashboardIcon from '../static/icons/dashboard.svg'
import tenantsIcon from '../static/icons/tenants.svg'

import pathnames from './pathnames'

export const MENU_ITEMS = [
  {
    title: 'Dashboard.Title',
    icon: dashboardIcon,
    route: pathnames.dashboard,
  },
  {
    title: 'Tenants.Title',
    icon: tenantsIcon,
    route: pathnames.tenants,
  },
]
